import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import type { Link } from '@readium/shared';
import { MetadataService } from '../../../services/metadata/metadata';
import { ReaderNavigatorService } from '../../../services/readium/navigator/reader-navigator';

@Component({
  selector: 'nr-toc',
  imports: [],
  templateUrl: './toc.html',
  styleUrl: './toc.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TocComponent {
  private readonly metadataService = inject(MetadataService);
  private readonly readerNavigatorService = inject(ReaderNavigatorService);

  readonly chapters = this.metadataService.chapters;
  // As in the previous NubeReader, a student who must answer each page's questions cannot jump.
  readonly isDisabled = this.metadataService.restrictNextPageWithQuestions;
  readonly nrNavigated = output();

  async navigateToChapter(chapter: Link): Promise<void> {
    if (this.isDisabled()) return;
    try {
      await this.readerNavigatorService.goToLink(chapter);
      console.log('navigating to chapter', this);
      this.nrNavigated.emit();
    } catch (err) {
      console.error(err);
    }
  }
}
